import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c39ebf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = { class: "ion-padding-horizontal" }
const _hoisted_3 = { class: "ion-padding-top" }

import {
  CurriculumCourse,
  CustomElement,
  SingleGradesParameters,
  LearningArea,
  LearningContext,
  Progression,
  AlternateList,
  TmpList,
  User,
  OrderedCardsList,
  GeneralTableCardElements,
} from "@/types";
import {
  executeLink,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getLearningContexts,
} from "@/utils";
import {
  IonModal,
  IonGrid,
  IonRow,
  IonCol,
  IonLabel,
  IonList,
  IonItem,
} from "@ionic/vue";
import { ref, watch } from "vue";
import { useStore } from "vuex";

type availableModal = "grades" | "course_details";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurriculumList',
  props: {
  student_id: String,
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const SetupModalAndOpen = () => {
  const window: availableModal = store.state.event.event;
  switch (window) {
    case "grades":
      grades_title = store.state.event.data.title;
      grades_parameters = store.state.event.data.parameters;
      grades_parameters.show_editable = false;
      grades_open.value = true;
      break;
    case "course_details":
      description_title = store.state.event.data.title;
      description_course_id = store.state.event.data.course_id;
      description_learning_session_id =
        store.state.event.data.learning_session_id;
      description_section = store.state.event.data.section;
      description_open.value = true;
      break;
  }
};
const closeModal = (window: availableModal) => {
  switch (window) {
    case "grades":
      grades_open.value = false;
      break;
    case "course_details":
      description_open.value = false;
  }
};
const getContextAcronym = (option: LearningContext) =>
  option[`${language}_title`];
const getYearCourses = async () => {
  year_courses = {};

  await executeLink(
    "/v2/students/" +
      reference_id +
      "/curriculum?school_year=" +
      selected_year.value, // context_id=" + selected_context.value + "&
    (response) => {
      let tmp_course: CurriculumCourse;

      for (const course of response.data.data) {
        tmp_course = new CurriculumCourse(course);
        if (year_courses[tmp_course.learning_context_id] == undefined) {
          year_courses[tmp_course.learning_context_id] = [];
        }
        year_courses[tmp_course.learning_context_id].push(tmp_course);
      }
    },
    () => []
  );

  courses = year_courses[selected_context.value] ?? [];
};
const updateCorrespondences = async () => {
  await getYearCourses();

  for (const context_courses of Object.values(year_courses)) {
    courses_list = courses_list.concat(context_courses);
  }

  await executeLink(
    "/v1/learning_sessions/correspondence?student_id=" + reference_id,
    (response) => {
      for (const correspondence of response.data.data) {
        if (year_correspondences[selected_year.value] == undefined) {
          year_correspondences[selected_year.value] = {};
        }
        if (
          year_correspondences[selected_year.value][correspondence.course_id] ==
          undefined
        ) {
          year_correspondences[selected_year.value][correspondence.course_id] =
            [];
        }
        year_correspondences[selected_year.value][
          correspondence.course_id
        ].push(correspondence.session_id);
      }
    },
    () => [],
    "post",
    {
      courses: courses_list.map((a: any) => a.id),
    }
  );
};
const updateTable = (
  year_correspondences: any,
  courses: CurriculumCourse[]
) => {
  for (const course of courses) {
    if (year_correspondences[selected_year.value][course.id].length > 0) {
      table_data.cards[""].push(
        course.toTableCard(
          year_correspondences[selected_year.value][course.id][
            year_correspondences[selected_year.value][course.id].length - 1
          ],
          user.id
        )
      );
    }
  }
};
const getAreaTitle = (key: string) => {
  const tmp_area = learning_areas.find((a) => a.id == key);
  return tmp_area != undefined ? tmp_area[`${language}_title`] : "";
};
const castToStringArray = (obj: TmpList<string[]> | string[]) =>
  obj as string[];
const castToTmpList = (obj: TmpList<string[]> | string[]) =>
  obj as TmpList<string[]>;

const store = useStore();
const user = User.getLoggedUser() as User;
const language = getCurrentLanguage();

const sections_use: boolean = store.state.sections_use;

const year_correspondences: {
  [key: number]: {
    [key: number]: number[];
  };
} = {};
const first_row: CustomElement[] = [
  {
    id: "title",
    type: "string",
    content: getCurrentElement("course"),
  },
  {
    id: "credits",
    type: "string",
    content: getCurrentElement("credits"),
  },
  {
    id: "learning_area",
    type: "string",
    content: getCurrentElement("learning_area"),
  },
  {
    id: "gardes",
    type: "string",
    content: getCurrentElement("grades"),
  },
  {
    id: "final_grade",
    type: "string",
    content: getCurrentElement("final_grade"),
  },
];
const column_sizes = sections_use
  ? ["4", "1", "1", "2", "2", "2"]
  : ["5", "1", "2", "2", "2"];
const grades_open = ref(false);
const description_open = ref(false);
const trigger = ref(0);
const reference_id: string =
  props.student_id != undefined && user.type != "student"
    ? props.student_id
    : "" + user.id;
const credits_progression: AlternateList<string[]> = {};
const selected_year = ref(0);
const selected_context = ref("");
const table_data: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};

let school_years: any[] = [];
let year_courses: {
  [key: string]: CurriculumCourse[];
} = {};
let courses: CurriculumCourse[] = [];
let grades_title: string;
let grades_parameters: SingleGradesParameters;
let description_title: string;
let description_course_id: number;
let description_learning_session_id: number;
let description_section: string;
let learning_contexts: LearningContext[] = [];
let learning_areas: LearningArea[] = [];
let courses_list: CurriculumCourse[] = [];

if (sections_use) {
  first_row.splice(1, 0, {
    id: "section",
    type: "string",
    content: getCurrentElement("section"),
  });
}

school_years =
  (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?descending=true&student_id=" + user.id,
        (response) => {
          return response.data.data.map((a: any) => {
            return {
              id: a.school_year,
            };
          });
        },
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
);
learning_contexts = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningContexts(user))),
  __temp = await __temp,
  __restore(),
  __temp
);
learning_areas = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_areas?all_data=true",
  (response) => response.data.data,
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);

selected_year.value = school_years[0].id;
selected_context.value = learning_contexts[0].id;

;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/students/" +
    reference_id +
    "/annual_credits?school_year=" +
    selected_year.value,
  (response) => {
    let tmp_context: string, tmp_area: string | null, tmp_status: string[];

    for (const progression of response.data.data as Progression[]) {
      tmp_context = (progression.learning_context_ref.data as { id: string })
        .id;
      tmp_area = (progression.learning_area_ref.data as { id: string | null })
        .id;
      tmp_status = [progression.credits, "" + progression.max_credits];
      if (tmp_area == null) {
        credits_progression[tmp_context] = tmp_status;
      } else {
        if (credits_progression[tmp_context] == undefined) {
          credits_progression[tmp_context] = {};
        }
        (credits_progression[tmp_context] as TmpList<string[]>)[tmp_area] =
          tmp_status;
      }
    }
  }
))),
  await __temp,
  __restore()
);

;(
  ([__temp,__restore] = _withAsyncContext(() => updateCorrespondences())),
  await __temp,
  __restore()
);
updateTable(year_correspondences, courses);
watch(selected_year, async () => {
  await updateCorrespondences();
  table_data.cards[""] = [];
  updateTable(year_correspondences, courses);
  trigger.value++;
});
watch(selected_context, (n) => {
  courses = year_courses[n] ?? [];
  table_data.cards[""] = [];
  updateTable(year_correspondences, courses);
  trigger.value++;
});

return (_ctx: any,_cache: any) => {
  const _component_grades_manager = _resolveComponent("grades-manager")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_course_description = _resolveComponent("course-description")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonModal), {
      id: "grades_manager",
      "is-open": grades_open.value,
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (closeModal('grades')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_grades_manager, {
              title: _unref(grades_title),
              parameters: _unref(grades_parameters),
              onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal('grades')))
            }, null, 8, ["title", "parameters"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      "is-open": description_open.value,
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (closeModal('course_details')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_course_description, {
              title: _unref(description_title),
              course_id: _unref(description_course_id),
              learning_session_id: '' + _unref(description_learning_session_id),
              section: _unref(description_section),
              onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal('course_details')))
            }, null, 8, ["title", "course_id", "learning_session_id", "section"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ionic_element, {
        element: 
          _unref(getCustomMessage)(
            'progression',
            _unref(getCurrentElement)('progression'),
            'title'
          )
        
      }, null, 8, ["element"]),
      _createElementVNode("div", _hoisted_3, [
        (Array.isArray(credits_progression[selected_context.value]))
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "ion-padding-horizontal" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getCurrentElement)("context_credits")) + ":", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(castToStringArray(credits_progression[selected_context.value]).join(
                  "/"
                )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_ionic_element, {
                element: 
              _unref(getCustomMessage)(
                'area_credits',
                _unref(getCurrentElement)('area_credits'),
                'title'
              )
            
              }, null, 8, ["element"]),
              _createVNode(_unref(IonList), { class: "ion-margin-top" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
                castToTmpList(credits_progression[selected_context.value])
              ), (area_progression) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), { key: area_progression }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getAreaTitle(area_progression)) + ":", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(castToTmpList(credits_progression[selected_context.value])[
                  area_progression
                ].join("/")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ], 64))
      ])
    ]),
    _createVNode(_unref(IonGrid), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { size: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_select, {
                  selected_option: selected_year.value,
                  "onUpdate:selected_option": _cache[4] || (_cache[4] = ($event: any) => ((selected_year).value = $event)),
                  list: _unref(school_years),
                  label: _unref(getCurrentElement)('school_year') + ':',
                  aria_label: _unref(getCurrentElement)('school_year'),
                  placeholder: _unref(getCurrentElement)('school_year_choice')
                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), { size: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_select, {
                  selected_option: selected_context.value,
                  "onUpdate:selected_option": _cache[5] || (_cache[5] = ($event: any) => ((selected_context).value = $event)),
                  list: _unref(learning_contexts),
                  label: _unref(getCurrentElement)('learning_context') + ':',
                  aria_label: _unref(getCurrentElement)('learning_context'),
                  placeholder: _unref(getCurrentElement)('learning_context_choice'),
                  getCompleteName: getContextAcronym
                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_ionic_table, {
          key: trigger.value,
          emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)('no_subscriptions'),
              'string',
              undefined,
              {
                label: {
                  align_text_middle: true,
                },
              }
            )
          ,
          data: table_data,
          first_row: first_row,
          sizes: _unref(column_sizes),
          onSignal_event: _cache[6] || (_cache[6] = ($event: any) => (SetupModalAndOpen()))
        }, null, 8, ["emptiness_message", "sizes"]))
      ]),
      fallback: _withCtx(() => [
        _createVNode(_component_loading_component)
      ]),
      _: 1
    }))
  ]))
}
}

})